/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebplaceholderaddress3Inputs */

const en_placewebplaceholderaddress3 = /** @type {(inputs: Placewebplaceholderaddress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your-website.com`)
};

const de_placewebplaceholderaddress3 = /** @type {(inputs: Placewebplaceholderaddress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deine-website.at`)
};

/**
* | output |
* | --- |
* | "your-website.com" |
*
* @param {Placewebplaceholderaddress3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebplaceholderaddress3 = /** @type {((inputs?: Placewebplaceholderaddress3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebplaceholderaddress3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebplaceholderaddress3(inputs)
	return de_placewebplaceholderaddress3(inputs)
});
export { placewebplaceholderaddress3 as "placeWebPlaceholderAddress" }